import { render, staticRenderFns } from "./PushToWordpress.vue?vue&type=template&id=46bcc36e&"
import script from "./PushToWordpress.vue?vue&type=script&lang=ts&"
export * from "./PushToWordpress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports